export default __webpack_public_path__ + "8094c93dfd4c5b5377f1349b0c2bf48b.png";